import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslocoPipe } from '@jsverse/transloco';
import { InputTextareaModule } from 'primeng/inputtextarea';

@Component({
  selector: 'app-textarea-input',
  standalone: true,
  imports: [FormsModule, CommonModule, InputTextareaModule, TranslocoPipe],
  templateUrl: './textarea-input.component.html',
  styleUrl: './textarea-input.component.css'
})
export class TextareaInputComponent {
  @Input() labelText: string = '';
  @Input() iconSrc: string | null = null;
  @Input() iconAltText: string = '';
  @Input() inputId: string = 'textarea';
  @Input() placeholder: string = '';
  @Input() errorMessage: string | null = null;
  @Input() isDisabled: boolean = false;
  @Input() rows: number = 5;
  @Input() cols: number = 30;

  @Input() textValue: string | undefined;
  @Output() textValueChange = new EventEmitter<string>();

  @Input() iconLeftOffset: number = 10;
  @Input() dividerOffset: number = 8;
  @Input() textInputOffset: number = 8;
  @Input() iconWidth: number = 20;
  @Input() iconHeight: number = 20;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['textValue'] && changes['textValue'].currentValue) {
      this.textValue = changes['textValue'].currentValue;
    }
  }

  onInputChange(event: Event) {
    const target = event.target as HTMLTextAreaElement;
    this.textValue = target?.value ?? '';
    this.textValueChange.emit(this.textValue);
  }

  getIconStyles(): { [key: string]: string } {
    return { left: this.iconLeftOffset + 'px' };
  }

  getDividerStyles(): { [key: string]: string } {
    return { left: (this.iconLeftOffset + this.iconWidth + this.dividerOffset) + 'px' };
  }

  getInputPaddingStyles(): { [key: string]: string } {
    if (this.iconSrc) {
      return { paddingLeft: `${this.iconLeftOffset + this.dividerOffset + this.iconWidth + this.textInputOffset}px` };
    } else {
      return { paddingLeft: `${this.textInputOffset}px` };
    }
  }

  getIconSizeStyles(): { [key: string]: string } {
    return {
      width: `${this.iconWidth}px`,
      height: `${this.iconHeight}px`,
    };
  }
}
